import React from 'react';
import styled from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { GlobalFonts } from '../../styles/GlobalFonts';
import { fiveTheoryLocales } from '../../locales/firstScreen';
import { Footer } from '../UI/Footer/Footer';

const LANG_KEY = 'stonpools-lang';

const Container = styled.div`
  background: #151515;
  min-height: 100vh;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 50px 10px;
  padding-bottom: 100px;
  box-sizing: border-box;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: auto;
  padding-bottom: 100px;
`;

const Title = styled.h2`
  color: #ffffff;
  font-family: 'Manrope', sans-serif;
  font-size: 44px;
  font-weight: 500;
  margin: 0vh 0 4vh;
  white-space: pre-line;
  line-height: 90%;
  text-align: center;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5vh 10px;
`;

const StyledImage = styled.img`
  object-fit: fill;
  height: 250px;
`;

const HighlightBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 350px;
  height: 60px;
  margin: 6vh auto 0;
  position: relative;
`;

const HighlightText = styled.span`
  color: #0180ff;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  width: 310px;
  line-height: 1.4;
  letter-spacing: -0.02em;
  white-space: pre-line;
  text-shadow:
    0 0 5px rgba(1, 128, 255, 0.4),
    0 0 10px rgba(1, 128, 255, 0.3),
    0 0 15px rgba(1, 128, 255, 0.2),
    0 0 20px rgba(1, 128, 255, 0.15),
    0 0 25px rgba(1, 128, 255, 0.1);
`;

const HomeButtonIcon = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
`;

const HomeButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  background-color: transparent;
`;

interface FiveTheory3Props {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  toHome?: () => void;
}

const FiveTheory3: React.FC<FiveTheory3Props> = ({
  onSwipeLeft,
  onSwipeRight,
  toHome,
}) => {
  const handlers = useSwipeable({
    onSwipedLeft: () => onSwipeLeft?.(),
    onSwipedRight: () => onSwipeRight?.(), // Теперь ведет на главную
    trackMouse: true,
    delta: 50,
    swipeDuration: 500,
  });

  const lang = (localStorage.getItem(LANG_KEY) as 'ru' | 'en') || 'ru';
  const t = fiveTheoryLocales[lang][3];

  return (
    <div {...handlers}>
      <GlobalFonts />
      <Container>
        <ContentWrapper>
          <MainContent>
            <HomeButton onClick={toHome}>
              <HomeButtonIcon src="/assets/homeIcon.svg" />
            </HomeButton>
            <Title>{t.title}</Title>
            <ImageContainer>
              <StyledImage src="/assets/Galka.svg" alt="Поздравляем" />
            </ImageContainer>
            <HighlightBox>
              <HighlightText>{t.highlight}</HighlightText>
            </HighlightBox>
          </MainContent>
          <Footer
            textLeft={t.back}
            textRight={t.practica}
            onSwipeLeft={onSwipeLeft}
            onSwipeRight={onSwipeRight}
          ></Footer>
        </ContentWrapper>
      </Container>
    </div>
  );
};

export default FiveTheory3;
